<template>
  <div class="OJProblemManagement">
    <div class="clearfix top">
      <div class="fl" style="margin-right:10px">
        <el-form ref="form" :model="form" :inline="true" size="mini">
          <el-form-item label="标题">
            <el-input
              v-model="form.title"
              prefix-icon="el-icon-search"
              placeholder="请输入标题"
              size="mini"
              clearable
              @keyup.enter.native="adminGetOjProblemList"
            ></el-input>
          </el-form-item>
          <el-form-item label="题目编号">
            <el-input
              v-model="form.code"
              prefix-icon="el-icon-search"
              placeholder="请输入题目编号"
              size="mini"
              clearable
              @keyup.enter.native="adminGetOjProblemList"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="fl">
        <el-form ref="form" :model="form" :inline="true" size="mini">
          <el-form-item label="所属">
            <el-select v-model="form.isPlatform" clearable>
              <el-option label="全部" value=""></el-option>
              <el-option label="平台" value="1"></el-option>
              <el-option label="校区" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否比赛题目">
            <el-select v-model="form.isContest" clearable>
              <el-option label="全部" value=""></el-option>
              <el-option label="公开题目" value="0"></el-option>
              <el-option label="比赛题目" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否可见">
            <el-select v-model="form.isVisible" clearable>
              <el-option label="全部" value=""></el-option>
              <el-option label="可见" value="1"></el-option>
              <el-option label="不可见" value="0"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="fl">
        <el-button
          type="primary"
          @click="search"
          icon="el-icon-search"
          size="mini"
          >查询</el-button
        >

        <el-button type="primary" @click="add" icon="el-icon-plus" size="mini"
          >添加问题</el-button
        >
        <!-- <el-button type="primary" @click="addmack" icon="el-icon-plus" size="mini">MarkDown添加问题</el-button> -->
      </div>
    </div>
    <el-divider></el-divider>
    <el-table
      size="mini"
      :data="tableData"
      stripe
      style="width: 100%"
      :header-cell-style="{ background: '#f5f7fa' }"
    >
      <el-table-column prop="sort_num" label="序号"> </el-table-column>
      <el-table-column prop="code" label="题目编号"> </el-table-column>
      <el-table-column prop="title" label="问题名称" show-overflow-tooltip>
      </el-table-column>

      <el-table-column prop="created_time" label="创建时间"> </el-table-column>
      <el-table-column label="标签">
        <template slot-scope="scope">
          <el-tag size="mini" v-if="scope.row.sourceTitle != null">{{
            scope.row.sourceTitle
          }}</el-tag>
          <span v-if="scope.row.problemTagArr.length === 0 ? false : true">
            <span v-for="item in scope.row.problemTagArr" :key="item.id">
              <el-tag size="mini" type="success">{{
                item.tagInfo.title
              }}</el-tag>
            </span>
          </span>
          <el-tag
            size="mini"
            v-if="scope.row.difficultyTitle != null"
            type="danger"
            >{{ scope.row.difficultyTitle }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column label="是否可见">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.visible"
            active-color="#409EFF"
            inactive-color="#ccc"
            @change="changeType(scope.row)"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column label="显示类型">
        <template slot-scope="scope">
          <span v-if="scope.row.description_show_type === 1">富文本</span>
          <span v-if="scope.row.description_show_type === 2">MarkDown</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180px">
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="edit(scope.row)"
            >编辑</el-button
          >
          <!-- adminDeleteOjProblem -->
          <el-button type="text" size="mini" @click="del(scope.row)"
            >删除</el-button
          >
          <el-button type="text" size="mini" @click="GoTopicAnalysis(scope.row)"
            >题解</el-button
          >
          <el-button
            type="text"
            size="mini"
            @click="handleBatchdownload(scope.row)"
            >下载</el-button
          >
          <!-- <el-link type="primary" :href="scope.row.attachment_url"
            >下载</el-link
          > -->

          <!-- <el-button type="text" size="mini">下载</el-button>
          <el-button type="text" size="mini">删除</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <div class="clearfix" style="margin-top: 20px;">
      <div class="fr" style=" text-align: right">
        <el-pagination
          @current-change="handleCurrent"
          :current-page="page_no"
          :page-size="page_size"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {
  adminGetOjProblemList,
  adminUpdateOjProblemVisible,
  adminDeleteOjProblem,
} from '@/api/adminOj.js'

import axios from 'axios'
import OSS from 'ali-oss'
import JSZip from 'jszip'
// import FileSaver from 'file-saver'
import { saveAs } from 'file-saver'
export default {
  data() {
    return {
      firstTime: true,
      form: {
        isVisible: '',
        isPlatform: '1',
      },
      page_no: 1,
      page_size: 20,
      total: 20,
      keyword: '',
      tableData: [],
    }
  },
  activated() {
    if (this.firstTime === false) {
      this.adminGetOjProblemList()
    }
  },
  mounted() {
    if (this.firstTime === true) {
      this.adminGetOjProblemList()
    }
  },
  methods: {
    del(row) {
      this.firstTime = false

      this.$confirm('是否确认删除', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          adminDeleteOjProblem({ problemId: row.id }).then(() => {
            this.$message({
              type: 'success',
              message: '删除成功!',
            })
            this.adminGetOjProblemList()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消删除！',
          })
        })
    },
    search() {
      this.page_no = 1
      this.adminGetOjProblemList()
    },
    changeType(val) {
      val.visible != val.visible
      console.log(val.visible)

      let visible1 = ''
      if (val.visible === true) {
        visible1 = '1'
      }
      if (val.visible === false) {
        visible1 = '0'
      }
      adminUpdateOjProblemVisible({
        id: val.id,
        visible: visible1,
      }).then((res) => {
        console.log(res)
        this.$message.success('更新成功！')
        this.adminGetOjProblemList()
      })
    },
    adminGetOjProblemList() {
      adminGetOjProblemList({
        ...this.form,
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        console.log('OJ题目列表')
        console.log(res)
        this.tableData = res.ojProblemList
        this.total = res.total
      })
    },

    handleCurrent(val) {
      this.page_no = val
      this.adminGetOjProblemList()
    },
    add() {
      sessionStorage.setItem('isMarkDown1', '2')

      this.$router.push({
        name: 'addSubject',
        query: {
          addType: '1',
        },
      })
    },
    // addmack() {
    //   sessionStorage.setItem('isMarkDown1', '1')

    //   this.$router.push({
    //     name: "addSubject",
    //     query: {
    //       addType: '2'
    //     }
    //   });
    // },
    GoTopicAnalysis(row) {
      this.firstTime = false

      this.$router.push({
        name: 'TopicAnalysis',
        query: {
          oj_problem_id: row.id,
          title: row.title,
        },
      })
    },
    edit(row) {
      this.firstTime = false
      console.log(row)
      sessionStorage.setItem('isMarkDown1', row.description_show_type)

      // if (row.md_description != null) {
      //   sessionStorage.setItem('isMarkDown1', '1')
      // } else {
      //   sessionStorage.setItem('isMarkDown1', '0')

      // }

      sessionStorage.setItem('problemDetails', JSON.stringify(row))
      this.$router.push({
        name: 'addSubject',
        query: {
          row: row.id,
          addType: '3',
        },
      })
    },
    // 批量下载
    handleBatchdownload(data) {
      if (!data.test_case_score) return this.$message.error('没有可下载的文件')
      this.$confirm('确定下载所有文件？', '下载确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const testCaseId = data.test_case_id
          const testZipName = data.code + data.title
          /**
           * input_name: "1.in",
           * output_name: "1.out",
           * score: 50,
           * stripped_output_md5: "e4da3b7fbbce2345d7772b0674a318d5"
           */
          const testCaseScoreArr = JSON.parse(data.test_case_score)
          // 1、获取阿里云相关信息
          const ossRes = await axios.get('/api/get/aliyun/sts', {
            headers: {
              Authorization: this.$store.state.user.token,
              'X-Requested-With': 'XMLHttpRequest',
            },
          })
          console.log('ossRes:', ossRes)
          let downloadUrlArr = []
          const clientOss = new OSS({
            region: 'oss-cn-zhangjiakou',
            accessKeyId: ossRes.data.AccessKeyId,
            accessKeySecret: ossRes.data.AccessKeySecret,
            stsToken: ossRes.data.SecurityToken,
            bucket: 'wugetestcase',
            secure: true,
          })
          console.log('clientOss:', clientOss)
          console.log(testCaseScoreArr)
          testCaseScoreArr.forEach((testItem) => {
            const inputUrl = `problem/${testCaseId}/${testItem.input_name}`
            const outputUrl = `problem/${testCaseId}/${testItem.output_name}`
            console.log('inputUrl:', inputUrl)
            downloadUrlArr.push(
              clientOss.signatureUrl(inputUrl),
              clientOss.signatureUrl(outputUrl)
            )
          })
          console.log(downloadUrlArr)
          // this.batchDownload(data.downloadUrl.split(',')) // 方法一，用jszip和file-saver第三方包
          this.batchDownload(downloadUrlArr, testZipName) // 方法一，用jszip和file-saver第三方包
        })
        .catch(() => {})
    },
    // 确定批量下载
    batchDownload(data, testZipName) {
      const zip = new JSZip()
      const cache = {}
      const promises = []
      data.forEach((item) => {
        const promise = this.getFile(item).then((data) => {
          // *下载文件, 并存成ArrayBuffer对象
          const arr_name = item.split('/')
          const file_name_arr = arr_name[arr_name.length - 1] // *获取文件名
          const file_name = file_name_arr.split('?')[0]
          zip.file(file_name, data, { binary: true }) // *逐个添加文件
          cache[file_name] = data
        })
        promises.push(promise)
      })
      Promise.all(promises).then(() => {
        zip
          .generateAsync({
            type: 'blob',
            compression: 'DEFLATE', // *STORE: 默认不压缩; DEFLATE：需要压缩
            compressionOptions: {
              level: 9, // *压缩等级 1~9。1: 压缩速度最快，9: 最优压缩方式
            },
          })
          .then((content) => {
            saveAs(content, testZipName + '.zip') // *生成二进制流，利用file-saver保存文件，文件名自定义
          })
      })
    },
    // 获取文件
    getFile(url) {
      return new Promise((resolve, reject) => {
        axios({
          method: 'get',
          url,
          responseType: 'blob',
        })
          .then((data) => {
            resolve(data.data)
          })
          .catch((error) => {
            reject(error.toString())
          })
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.OJProblemManagement {
  margin: 10px;
  padding: 20px;

  background: white;
  border-radius: 5px;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

.clearfix:after {
  content: '';
  display: block;
  visibility: hidden;
  clear: both;
}

.top {
  font-size: 18px;
  font-weight: 300;
}

/deep/ .el-radio-group {
  margin-top: 7px;
}

/deep/ .el-divider--horizontal {
  margin-top: 0px;
}
</style>
